import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SimXInstitution } from '../../../shared/models/entities/simx-institution.model';
import { State } from './institution-store.state';

const getEntityList = (state: State): Array<SimXInstitution> =>
  state.entityList;
const getIsLoadingEntityList = (state: State): boolean =>
  state.isLoadingEntityList;
const getHasLoadedEntityList = (state: State): boolean =>
  state.hasLoadedEntityList;
const getLoadEntityListError = (state: State): string | null =>
  state.loadEntityListError;

export const selectInstitutionState =
  createFeatureSelector<State>('institution');

export const selectInstitutionList = createSelector(
  selectInstitutionState,
  getEntityList,
);
export const selectIsLoadingInstitutionList = createSelector(
  selectInstitutionState,
  getIsLoadingEntityList,
);
export const selectHasLoadedInstitutionList = createSelector(
  selectInstitutionState,
  getHasLoadedEntityList,
);
export const selectLoadInstitutionListError = createSelector(
  selectInstitutionState,
  getLoadEntityListError,
);
